import styled, { css } from 'styled-components'

export const ToggleHighlight = styled.div`
  ${({ active }) => active && css`
    border: 1px solid ${({ theme }) => theme.palette.success[0] };
    color: ${({ theme }) => theme.palette.success[0] };
    background-color: ${({ theme }) => theme.palette.success[4] };
    padding: 0.1rem 0.5rem;
    margin-top: -0.2rem;
    width: fit-content;
  `}
`

export const TableWrapper = styled.div`
  .table {
    th {
      width: 8rem;
    }
    
    th:nth-child(2) {
      width: auto;
    }
    
    th:nth-child(6) {
      width: 12rem;
    }
  }
`
